import type { TaskStackedOn } from '@shared/types/tasks';
import { formatTaskNumber } from '@shared/task-number';

/** What to do once the stacked-on task's PR is merged. */
export function stackedMergedText(stackedOn: TaskStackedOn, taskPrefix?: string | null): string {
  const ref = formatTaskNumber(stackedOn.number, taskPrefix);
  return `${ref}'s PR is merged, so this task's PR should go against the default branch now. GitHub moves it there when ${ref}'s branch was deleted on merge; otherwise change the PR's base.`;
}
